import { render, staticRenderFns } from "./DownholeSensor.vue?vue&type=template&id=53594a12&"
import script from "./DownholeSensor.vue?vue&type=script&lang=js&"
export * from "./DownholeSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports